// Filename: bumble.js
// Timestamp: 2018.01.19-23:55:13 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import { gnweb_init } from '@bumblehead/gani'
import iswebglcontext from 'iswebglcontext'
import curved from 'curved'
import touchboom from 'touchboom'
import lockfnthrottling from 'lockfn/throttling'
import bumble_cfg from './bumble_cfg.js'
import './bumble_sentry.js'

import {
  Mesh as THREEMesh,
  MeshBasicMaterial as THREEMeshBasicMaterial,
  MeshNormalMaterial as THREEMeshNormalMaterial,
  Object3D as TRHEEObject3D,
  Raycaster as THREERaycaster,
  Vector2 as THREEVector2,
  Vector3 as THREEVector3,
  Scene as THREEScene,
  GridHelper as THREEGridHelper,
  FrontSide as THREEFrontSide,
  SphereGeometry as THREESphereGeometry,
  WebGLRenderer as THREEWebGLRenderer,
  PerspectiveCamera as THREEPerspectiveCamera,
  BufferGeometry as THREEBufferGeometry,
  BufferAttribute as THREEBufferAttribute,
  LineSegments as THREELineSegments,
  EdgesGeometry as THREEEdgesGeometry,
  LineBasicMaterial as THREELineBasicMaterial
} from 'three'

const win = typeof window === 'object' ? window : {},
      location = win.location || {},
      href = location.href

const start = (version, startts) => {
  gnweb_init(bumble_cfg, {
    version,
    startts,
    origin: window.location.origin,
    // specpath: '/spec/view/',
    specpath: '/spec/',
    dirs_path: '/',
    islocallinkdynamic: true,
    islogenabled: href.includes('islogenabled=true'),
    iswebgl: iswebglcontext,
    fpms: iswebglcontext && 20,

    // could be defined in json by specfile
    // list of delay nodes would be surfaced
    // and remade
    delaydatanode: true,

    // add error to errnode
    specerrfn: (sess, cfg, graph, node, err, fn) => (
      cfg.speccb.surfaceerror([ err ], {}, (err, graph) => {
        fn(err, graph)
      }, sess, cfg, graph, node)
    ),

    initcfg: cfg => {
      cfg.curved = curved
      cfg.touchboom = touchboom
      cfg.lockfnthrottling = lockfnthrottling
      cfg.THREE = {
        Mesh: THREEMesh,
        MeshBasicMaterial: THREEMeshBasicMaterial,
        MeshNormalMaterial: THREEMeshNormalMaterial,
        LineBasicMaterial: THREELineBasicMaterial,
        Raycaster: THREERaycaster,
        Vector2: THREEVector2,
        Vector3: THREEVector3,
        Object3D: TRHEEObject3D,
        Scene: THREEScene,
        GridHelper: THREEGridHelper,
        FrontSide: THREEFrontSide,
        WebGLRenderer: THREEWebGLRenderer,
        PerspectiveCamera: THREEPerspectiveCamera,
        LineSegments: THREELineSegments,
        EdgesGeometry: THREEEdgesGeometry,
        BufferGeometry: THREEBufferGeometry,
        SphereGeometry: THREESphereGeometry,
        BufferAttribute: THREEBufferAttribute
      }

      return cfg
    }
  }, {
    window
  })
}

if (typeof window === 'object') {
  start(
    window.appversion,
    window.pagestart)
}

export default {
  start
}
